import { Link } from "react-router-dom"; // ✅ thêm import
import { motion } from "framer-motion";
import "../../styles/code/HolisticDevelopmentSection.css";

const overview = {
  image: "/images/code/holistic/holistic1.webp",
  title: "Phát triển toàn diện",
  subtitle: "Mở khóa tương lai",
  description:
    "Nhiều hoạt động ngoại khoá thú vị, bổ ích giúp học viên phát triển tư duy phản biện, kỹ năng giao tiếp, làm việc nhóm, v.v.",
  text: "Chương trình dành riêng cho học viên đăng ký các khoá bảo trợ từ 2 năm trở lên, giúp trang bị kiến thức khởi nghiệp từ nghiên cứu thị trường, làm kế hoạch kinh doanh cho đến gọi vốn",
};

const contents = [
  {
    image: "/images/code/holistic/holistic2.webp",
    title: "Tự tin hơn với chuỗi Workshop Kĩ năng mềm Xskill",
    text: "Cơ hội phát triển kỹ năng thuyết trình, thiết kế, chỉnh sửa video, v.v. để thích ứng tốt hơn khi thế giới biến đổi không ngừng",
  },
  {
    image: "/images/code/holistic/holistic3.webp",
    title: "Workshop định hướng nghề nghiệp",
    text: "Cập nhật các xu thế ngành nghề-kỹ năng-ngành học hấp dẫn của thời đại số qua các buổi workshop định hướng nghề nghiệp tại Design24",
  },
];

const fadeDownVariants = {
  hidden: { opacity: 0, y: -50 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

function HolisticDevelopmentSection() {
  return (
    <section className="holistic-section">
      {/* --- Block giới thiệu đầu tiên --- */}
      <motion.div
        className="holistic-intro"
        variants={fadeDownVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <div className="holistic-intro-text">
          <h2 className="holistic-heading__text">
            <span>
              Phát triển{" "}
              <span className="holistic-heading__highlight">toàn diện</span>
            </span>
            <span>
              <span className="holistic-heading__highlight">Mở khóa</span> tương
              lai
            </span>
          </h2>

          <p>{overview.description}</p>
          <h3 className="holistic-title">
            Trở thành nhà khởi nghiệp tương lai với NextGen
          </h3>
          <p>{overview.text}</p>

          {/* ✅ dùng Link thay a */}
          <Link
            to="/chi-tiet"
            className="holistic-link"
          >
            Tìm hiểu thêm
          </Link>
        </div>
        <div className="holistic-intro-image">
          <img
            src={overview.image}
            alt="Phát triển toàn diện"
          />
        </div>
      </motion.div>

      {/* --- Các khối nội dung bên dưới --- */}
      <div className="holistic-content">
        {contents.map((item, index) => (
          <motion.div
            className={`holistic-block ${
              index % 2 === 0 ? "left-img" : "right-img"
            }`}
            key={index}
            variants={fadeDownVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            custom={index + 1}
          >
            <div className="holistic-image">
              <img
                src={item.image}
                alt={item.title}
              />
            </div>
            <div className="holistic-text">
              <h3 className="holistic-title">{item.title}</h3>
              <p className="holistic-description">{item.text}</p>

              {/* ✅ dùng Link thay a */}
              <Link
                to="/chi-tiet"
                className="holistic-link"
              >
                Tìm hiểu thêm
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default HolisticDevelopmentSection;
